import { render, staticRenderFns } from "./DropPromptCenter.vue?vue&type=template&id=942c7a1a&scoped=true&"
import script from "./DropPromptCenter.vue?vue&type=script&lang=js&"
export * from "./DropPromptCenter.vue?vue&type=script&lang=js&"
import style0 from "./DropPromptCenter.vue?vue&type=style&index=0&id=942c7a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942c7a1a",
  null
  
)

export default component.exports